import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import * as _ from 'lodash';
import { SharedService } from 'app/shared/services/shared.service';
import { UserService } from 'app/shared/services/user.service';

@Injectable()
export class AppHttpInterceptor implements HttpInterceptor {

    constructor(public sharedService: SharedService, public userService: UserService) { }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(request)
            .do((event: any) => {
                const requestUrl: Array<string> = request.url.split("/");
                let networkId: string;
                let network: any;
                if (this.userService.isAdmin() && event instanceof HttpResponse) {
                    networkId = event.headers.get('network-id');
                    if (this.userService.networkData && requestUrl[requestUrl.length - 1] !== 'setNetwork' && networkId !== this.userService.networkData.networkId.toString()) {
                        network = _.find(this.sharedService.activeNetworks, { 'networkId': networkId });
                        if (network) {
                            this.userService.networkData.networkId = Number(networkId);
                            this.userService.changeNetwork(network, true);
                        }
                    }
                }
            });
    }
}